import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import Img from 'gatsby-image';
import { WithIntl } from '../components/language/with-intl.js';
import Layout from '../components/layout';
import SEO from '../components/seo';
import { useTranslation } from 'react-i18next';
import { LocalizedLink } from '../components/language/localized-link';

import Sponsor from '../assets/img/illustrations/sponsor.inline.svg';

const About = ({ language }) => {
    const data = useStaticQuery(graphql`
        query {
            about1: file(relativePath: { eq: "about/about1.jpg" }) {
                childImageSharp {
                    fluid(quality: 90) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
            about2: file(relativePath: { eq: "about/about2.jpg" }) {
                childImageSharp {
                    fluid(quality: 90) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
            about3: file(relativePath: { eq: "about/about3.jpg" }) {
                childImageSharp {
                    fluid(quality: 90) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
            about4: file(relativePath: { eq: "about/about4.jpg" }) {
                childImageSharp {
                    fluid(quality: 90) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
            about5: file(relativePath: { eq: "about/about5.jpg" }) {
                childImageSharp {
                    fluid(quality: 90) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
            about6: file(relativePath: { eq: "about/about6.jpg" }) {
                childImageSharp {
                    fluid(quality: 90) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
            about7: file(relativePath: { eq: "about/about7.jpg" }) {
                childImageSharp {
                    fluid(quality: 90) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
            about8: file(relativePath: { eq: "about/about8.jpg" }) {
                childImageSharp {
                    fluid(quality: 90) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
            about9: file(relativePath: { eq: "about/about9.jpg" }) {
                childImageSharp {
                    fluid(quality: 90) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
            about10: file(relativePath: { eq: "about/about10.jpeg" }) {
                childImageSharp {
                    fluid(quality: 90) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
            mitropolitiko: file(relativePath: { eq: "spotlight/mitropolitiko-logo.jpg" }) {
                childImageSharp {
                    fixed(quality: 90, width: 200) {
                        ...GatsbyImageSharpFixed
                    }
                }
            }
            iriotis: file(relativePath: { eq: "spotlight/iriotis-logo.jpg" }) {
                childImageSharp {
                    fixed(quality: 90, width: 200) {
                        ...GatsbyImageSharpFixed
                    }
                }
            }
        }
    `);
    const { t } = useTranslation();

    return (
        <Layout>
            <SEO title={t('about.seo_title')} description={t('about.seo_description')} />
            <section className="mt-10 mb-10">
                <div className="container col-12 header">
                    <div className="row align-items-stretch">
                        <div className="col-12 col-lg-11 col-xl-9 ml-auto mr-auto text-center">
                            <h1 className="display-1 font-weight-bold">
                                {t('about.title_pt1')} <span className="text-primary">{t('about.title_pt2')}</span>
                            </h1>
                            <p className="lead text-gray-800 mt-6">{t('about.subheading')}</p>
                        </div>
                    </div>
                    <div className="row mt-10 mt-md-14">
                        <div className="col-12 col-md-10 offset-md-1 col-xl-8 offset-xl-2">
                            <div className="form-row">
                                <div className="col-6 col-md-4 mb-5 mb-md-0">
                                    <Img
                                        fluid={data.about1.childImageSharp.fluid}
                                        className="img-fluid rounded shadow-lg mt-n8"
                                        alt="WeSolve Project Uniform"
                                    />
                                    <Img
                                        fluid={data.about3.childImageSharp.fluid}
                                        className="img-fluid rounded shadow-lg d-md-none mt-5"
                                        alt="WeSolve converting ideas into actions"
                                    />
                                </div>
                                <div className="col-6 col-md-3 mb-5 mb-md-0">
                                    <Img
                                        fluid={data.about2.childImageSharp.fluid}
                                        className="img-fluid rounded shadow-lg mb-4"
                                        alt="WeSolve is think tank created by greek law students"
                                    />
                                    <Img
                                        fluid={data.about9.childImageSharp.fluid}
                                        className="img-fluid rounded shadow-lg mt-1"
                                        alt="Young law students created the first think tank in Greece"
                                    />
                                </div>
                                <div className="col-12 col-md-5">
                                    <div className="form-row mb-4">
                                        <div className="col-6 col-md-5 mb-5 mb-md-0">
                                            <Img
                                                fluid={data.about6.childImageSharp.fluid}
                                                className="img-fluid rounded shadow-lg"
                                                alt="First student think tank in Greece"
                                            />
                                        </div>
                                        <div className="col-6 col-md-7 mb-5 mb-md-0">
                                            <Img
                                                fluid={data.about4.childImageSharp.fluid}
                                                className="img-fluid rounded shadow-lg"
                                                alt="WeSolve Think Tank Team Organization"
                                            />
                                        </div>
                                    </div>
                                    <Img
                                        fluid={data.about3.childImageSharp.fluid}
                                        className="img-fluid rounded shadow-lg mt-1 d-none d-md-block"
                                        alt="WeSolve Team Open Discussion"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <div className="position-relative mt-n15 mt-md-n10 mt-lg-0">
                <div className="shape shape-bottom shape-fluid-x svg-shim text-gray-200">
                    <svg viewBox="0 0 2880 690" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0 345H1437.5H2880V0C1437.5 462.106 0 0 0 0V345Z" fill="#336699" />
                    </svg>
                </div>
            </div>
            <section className="bg-secondary py-15">
                <div className="container col-12">
                    <div className="row align-items-stretch">
                        <div className="col-12 col-md-7 col-xl-6 mb-10 mb-md-0">
                            <h1 className="display-2 font-weight-bold text-white ml-5 mt-xl-10">{t('about.heading2')}</h1>
                            <p className="lead text-white mt-6 ml-5">{t('about.about_us')}</p>
                        </div>
                        <div className="col-12 col-md-5 col-xl-5 offset-xl-1">
                            <div className="row mt-md-10 mt-lg-0">
                                <div className="col-6 mr-n5">
                                    <Img
                                        fluid={data.about7.childImageSharp.fluid}
                                        alt="WeSolve Think Tank Greece"
                                        className="img-fluid mb-4 rounded aos-init aos-animate"
                                        data-aos="fade-right"
                                        data-aos-delay="100"
                                    />
                                </div>
                                <div className="col-6">
                                    <Img
                                        fluid={data.about5.childImageSharp.fluid}
                                        alt="WeSolve Solving Problems Together"
                                        className="img-fluid mb-4 rounded aos-init aos-animate"
                                        data-aos="fade-right"
                                    />
                                </div>
                                <div className="col-12">
                                    <Img
                                        fluid={data.about8.childImageSharp.fluid}
                                        alt="WeSolve Think Tank Team"
                                        className="img-fluid mb-4 rounded aos-init aos-animate"
                                        data-aos="fade-right"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="bg-white py-10 mb-n5">
                <div className="container">
                    <div className="row">
                        <div className="col-12 ml-auto mr-auto text-center">
                            <h1 className="display-2 font-weight-bold">
                                {t('about.heading3')} <span className="text-primary">WeSolve?</span>
                            </h1>
                            <p className="lead text-gray-800 mt-6">{t('about.why_wesolve')}</p>
                        </div>
                        <div className="col-12 col-lg-10 offset-lg-1 col-xl-8 offset-xl-2">
                            <Img
                                fluid={data.about10.childImageSharp.fluid}
                                alt="About WeSolve Sponsors"
                                className="img-fluid rounded mt-10"
                                data-aos="fade-up"
                            />
                        </div>
                    </div>
                </div>
            </section>

            <section className="bg-white py-10">
                <div className="container">
                    <div className="row text-center">
                        <div className="col-12 mt-10 text-gray-800">{t('about.sponsors')}</div>
                    </div>
                    <div className="row text-center mt-md-8 mt-4 mt-md-0">
                        <div className="col-12 col-md-4">
                            <div className="card-sponsor">
                                <a href="https://mitropolitiko.edu.gr/" target="_blank" rel="noreferrer noopener">
                                    <Img fixed={data.mitropolitiko.childImageSharp.fixed} alt="Mitropolitiko Logo" className="card-sponsor-image" />
                                </a>
                            </div>
                        </div>
                        <div className="col-12 col-md-4 order-md-2">
                            <div className="card-sponsor">
                                <a href="https://www.iriotislaw.gr/" target="_blank" rel="noreferrer noopener">
                                    <Img fixed={data.iriotis.childImageSharp.fixed} alt="Iriotis Law Firm Logo" className="card-sponsor-image" />
                                </a>
                            </div>
                        </div>
                        <div className="col-12 col-md-4 order-md-1 mt-4 mt-md-0">
                            <LocalizedLink to="/contact" className="text-decoration-none">
                                <div className="card shadow shadow-lg bg-gradient lift cursor-pointer">
                                    <div className="card-body">
                                        <h2 className="text-white">{t('about.cta')}</h2>
                                        <Sponsor className="mt-n10 mb-n10 w-sponsor" />
                                    </div>
                                </div>
                            </LocalizedLink>
                        </div>
                    </div>
                </div>
            </section>
        </Layout>
    );
};

export default WithIntl()(About);
